// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__a4VFF","upload":"Small_upload__UBbxe","imageWrap":"Small_imageWrap__3HQaf","removeBtn":"Small_removeBtn__C6SlY"};